import { en } from './en';
import { he } from './he';
import type { TranslationKey } from './en';

const dictionaries = { en, he } as const;
type Locale = keyof typeof dictionaries;

let currentLocale: Locale = 'he';

export function setLocale(locale: string): void {
  if (locale in dictionaries) {
    currentLocale = locale as Locale;
  }
}

export function t(key: TranslationKey): string {
  return dictionaries[currentLocale][key] ?? dictionaries.en[key] ?? key;
}

export function getLocale(): string {
  return currentLocale;
}

export function getDirection(): 'ltr' | 'rtl' {
  return currentLocale === 'he' ? 'rtl' : 'ltr';
}

export type { TranslationKey };
